import Styles from "./contact.module.css";
import { sendEmail } from "./email";
import { SubHeader, Input, Button } from "../../subcomponents/subcomponents";
import { useState } from "react";
export const EmailUs = ( props ) => {
    const {  } = props;
    const { EmailUs, EmailInputs } = Styles;
    const [ ready, setReady ] = useState(false);
    const checkInputs = _=>{
        const input = document.querySelectorAll("input")[0];
        const textarea = document.querySelectorAll("textarea")[0];
        if( input.value !== "" && textarea.value !== "") setReady(true);
        else setReady(false);
    };
    return (
        <form className={ EmailUs } onSubmit={ e => sendEmail( e ) }>
            <SubHeader icon={ <i className="bi bi-envelope"></i> } text={ "Email Us" }/>
            <main className={ EmailInputs }>
                <Input
                    onChange = { checkInputs }
                    type   = { "email" }
                    name   = { "user_email" }
                    text   = { "Enter Your Email" }
                    icon   = { <i className="bi bi-envelope-at-fill" style={{ color: "#999" }}></i> }
                    height = { 50 }
                    theme  = { "#444" }
                    color  = { "#999" }
                />
                <TextArea onChange = { checkInputs }/>
                <Button
                    type    = { "submit" }
                    icon    = { <i className="bi bi-envelope-arrow-up-fill"></i> }
                    text    = { "Submit" }
                    theme   = { ready ? "#999" :"#444" }
                    width   = { 135 }
                />
            </main>
            <Footer />
        </form>
    );
};
const TextArea = ( props ) => {
    const { onChange } = props;
    const { TextArea } = Styles;
    return (
        <div className={ TextArea }>
            <header>
                <i className="bi bi-textarea-t"></i>
                <span></span>
                <span>Your Text</span>
            </header>
            <textarea onChange={ onChange } name="message" required></textarea>
        </div>
    );
};
const Footer = ( props ) => {
    const {  } = props;
    const { Footer } = Styles;
    const arrrayLinks = [
        {icon: <i className="bi bi-facebook"></i>, link: "#"},
        {icon: <i className="bi bi-tiktok"></i>, link: "#"},
        {icon: <i className="bi bi-instagram"></i>, link: "#"},
        {icon: <i className="bi bi-telegram"></i>, link: "#"},
        {icon: <i className="bi bi-discord"></i>, link: "#"},
        {icon: <i className="bi bi-github"></i>, link: "#"},
        {icon: <i className="bi bi-twitter-x"></i>, link: "#"}
    ];
    return (
        <footer className={ Footer }>
            <div>
                {
                    arrrayLinks.map(( value, key ) => { 
                        const { icon, link } = value;
                        return <a href={ link } key={ key }>{ icon }</a> 
                    }
                )}
            </div>
        </footer>
    );
};